import { getAccessToken } from '../../../../shared/utils/accessTokenStore';
import { LOGIN, PASSWORD, SIGNUP, UNLOCK } from '../endpoints';

const UNAUTHENTICATED_PATHS = new Set([LOGIN, PASSWORD, SIGNUP, UNLOCK]);

const authInterceptor = [
  (config) => {
    if (UNAUTHENTICATED_PATHS.has(config.url)) return config;

    const jwt = getAccessToken();
    if (jwt) config.headers.Authorization = jwt;

    return config;
  },
  (error) => Promise.reject(error),
  { synchronous: true },
];

export default authInterceptor;
